import React, {PropsWithChildren} from 'react';
import {observer} from "mobx-react";
import {UsefulLinksItemBox} from "../../boxes/item/useful-links-item.box";
import {get} from 'lodash';
import {useServices} from "../../../../react-hooks/use-services.hook";
import {Image} from "../../../raw-components/image/image";
import {UsefulLinksItemSideTextBox} from "../../boxes/item-side-text/useful-links-item-side-text.box";
import {MenuItemComponentProps} from "../../../../services/menu-items-common/menu-item-component-props.interface";
import {UserMenuSeparatorBox} from '../../../user-menu/user-menu-items/boxes/separator/user-menu-separator.box';
import {FlexFixedSizeItemBox, FlexGrowItemBox} from '../../../../themes/architecture/css-helpers/flex';
import {Check} from '@sparkware/app-utils';
import {GenericSideMenuItemIconBox} from '../../../side-menu-rework/side-menu-items/boxes/link/generic/generic-side-menu-item-icon.box';
import {CyClass} from '../../../../../common/cy-classes';
import classNames from 'classnames';

interface IUsefulLinkInnerItemComponentProps extends MenuItemComponentProps {
    className?: string;
    // false - collapsed state, arrow down // true - expanded state, arrow up // undefined or null - normal state, arrow to the right
    expandedArrowIcon?: boolean | undefined | null;
    onClick(): void;
}

export const UsefulLinkInnerItemComponent: React.FC<PropsWithChildren<IUsefulLinkInnerItemComponentProps>> = observer((props) => {
    const services = useServices();


    const _renderIcon = () => {
        if(!props.menuItem.iconSource || !props.menuItem.icon) {
            return null;
        }

        switch (props.menuItem.iconSource) {
            case "themeIcons":
                const Icon = services.theme.currentTheme.icons[props.menuItem.icon];
                if(!Icon) {
                    services.logger.error(`Menu item ${props.menuItem.key} has configured icon ${props.menuItem.icon} which does not exist in currentTheme.icons`)
                    return null;
                }
                return (<Icon size={2} title={props.menuItem.iconAltText ?? '' } />);
                // break;
            case "themeImages":
                const imageURI = get(services.theme.currentTheme.images, props.menuItem.icon, '');
                if(!imageURI) {
                    services.logger.error(`Menu item ${props.menuItem.key} has configured icon ${props.menuItem.icon} which does not exist in currentTheme.images`)
                    return null;
                }
                return (<Image src={imageURI} alt={props.menuItem.iconAltText ?? '' } style={{display: "block"}}/>)
                // break;
            case "url":
            default:
                return (<Image src={props.menuItem.icon} alt={props.menuItem.iconAltText ?? '' }/>)
                // break;
        }
    }

    const renderContent = () => {
        if(props.menuItem.imageOnlyRendering) {
            return _renderIcon();
        } else {
            return (
                <>
                    <GenericSideMenuItemIconBox>
                        {_renderIcon()}
                    </GenericSideMenuItemIconBox>
                    <FlexGrowItemBox>
                        {props.menuItem.text}
                    </FlexGrowItemBox>
                    {props.menuItem.sideText && (<UsefulLinksItemSideTextBox className='cy-useful-links-item-side-text'>{props.menuItem.sideText}</UsefulLinksItemSideTextBox>)}
                </>
            )
        }
    }

    const ForwardIcon = services.theme.currentTheme.icons.forwardIcon;
    let iconStyle = {};
    if (!Check.isNullOrUndefined(props.expandedArrowIcon)) {
        iconStyle = {
            transition: "transform 0.12s ease-out",
            transform: "rotate(" + (props.expandedArrowIcon ? "-" : "") + "90deg)" 
        };
    }

    return (
        <li key={props.menuItem.key} onClick={props.onClick} className={CyClass('cy-useful-links-li-item')}>
            {!!props.showSeparator && <UserMenuSeparatorBox />}
            <UsefulLinksItemBox active={props.expandedArrowIcon === true} className={classNames(props.className, CyClass('cy-useful-links-item'))}>
                {renderContent()}
                {!props.menuItem.imageOnlyRendering && <FlexFixedSizeItemBox>
                    <ForwardIcon size={1.2} style={iconStyle} />
                </FlexFixedSizeItemBox>}
            </UsefulLinksItemBox>
            {props.children}
        </li>
    );

});